module.exports = __webpack_public_path__ + "static/media/pltlogo.c4e1f15e.webp";